import LoadingSpinner from '@material-ui/core/CircularProgress';
import React, { CSSProperties } from 'react';

export interface LoaderProps {
  color?: 'primary' | 'secondary' | 'inherit';
  variant?: 'determinate' | 'indeterminate' | 'static';
  disableShrink?: boolean;
  size?: number | string;
  thickness?: number;
  style?: CSSProperties;
}

export const Loader = ({
  color,
  variant,
  disableShrink,
  size,
  thickness,
  style,
}: LoaderProps) => (
  <LoadingSpinner
    color={color}
    variant={variant}
    disableShrink={disableShrink}
    size={size}
    thickness={thickness}
    style={style}
  />
);
